import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'


const object = vnObject

Fancybox.bind(`[data-gallery="gallery-agency"]`, {
    groupAll: true,
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },
    Thumbs: {
        type: 'classic',
    },
})
